<span class="group inline-flex items-center">
    <span class="font-headline {{ white() ? 'text-white' : 'text-grey-400' }} text-16 leading-20 group-hover:underline">
        <ng-content />
    </span>
    <i
        class="icon-share text-24 ml-8"
        [ngClass]="[white() ? 'text-white' : 'text-grey-400', '']"
        aria-hidden="true"
    ></i>
</span>
